<template>
  <!-- 店家banner -->
  <v-sheet class="sm:(wd-my-6)" elevation="0" rounded>
    <v-img
      class="sm:(wd-rounded) wd-overflow-hidden"
      :src="getImage(branch.cover_image)"
      height="300"
      gradient="to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4)"
      cover
    >
      <div v-if="!hideText" class="wd-absolute wd-left-5 wd-bottom-5">
        <h1 class="wd-text-2xl wd-font-medium wd-mb-1 wd-text-white">{{ branch.name }}</h1>
        <div class="wd-text-obase wd-max-h-6 wd-flex wd-items-center wd-text-white">
          <funnow-icon class="wd-mr-1" max-width="20" :image-path="'star_white.svg'" />
          <span> {{ `${branch.rating} (${branch.number_of_comments})` }} </span>
        </div>
      </div>
    </v-img>
  </v-sheet>
</template>

<script>
import FunnowIcon from '@/components/icons/funnow-icon.vue'
import utils from '@/utils'

export default defineComponent({
  components: {
    FunnowIcon,
  },
  props: {
    branch: { type: Object, default: () => ({}) },
    hideText: { type: Boolean, default: false },
  },
  setup() {
    function getImage(path) {
      return utils.imageUrl(path)
    }

    return {
      getImage,
    }
  },
})
</script>
